<template>
  <div class="report-page">
    <!-- 报告容器（用于生成长图） -->
    <div ref="reportRef" class="report-container" id="pdf-content">
      <!-- 头部 -->
      <div class="page">
        <div class="title_box">
          <div class="title">龙猫体质测试分析报告</div>
          <div class="cardRoll_box">
            <div class="cardRoll_badgetopbox">
              <img
                v-show="finalScoreData.level === '优秀'"
                src="@/assets/parentImg/优秀.png"
                width="100%"
                alt=""
              />
              <img
                v-show="finalScoreData.level === '良好'"
                src="@/assets/parentImg/良好.png"
                width="100%"
                alt=""
              />
              <img
                v-show="finalScoreData.level === '及格'"
                src="@/assets/parentImg/及格.png"
                width="100%"
                alt=""
              />
              <img
                v-show="finalScoreData.level === '不及格'"
                src="@/assets/parentImg/不及格.png"
                width="100%"
                alt=""
              />
            </div>
            <div class="cardRoll_topbox">
              <div class="year_score">
                <span style="font-size: clamp(16px, 11vw, 60px); font-weight: 700">{{
                  finalScoreData.finalWeightScore
                }}</span>
                <span>分</span>
              </div>
              <!-- <div style="font-size: 14px; color: #333;">{{ student.name || '学生' }}</div> -->
            </div>
            <div class="cardRoll_bottombox">
              <div class="line"></div>
              <div class="card">
                <div class="cardRoll_bottombox_top">
                  <div class="cardRoll_bottombox_topleft">
                    {{ BmiData.height || "--"
                    }}<span style="font-size: 16px">cm</span>
                  </div>
                  <div class="cardRoll_bottombox_topright">
                    {{ BmiData.weight || "--"
                    }}<span style="font-size: 16px">kg</span>
                  </div>
                </div>
                <div class="cardRoll_bottombox_bottom">
                  <div class="cardRoll_bottombox_bottomtop">
                    <div class="cardRoll_bottombox_bottomtopleft">当前BMI</div>
                    <div class="cardRoll_bottombox_bottomtopright">
                      <div>{{ BmiData.value || "--" }}</div>
                      <div class="cardRoll_bottombox_bottomtopright_text">
                        {{ BmiData.level || "--" }}
                      </div>
                    </div>
                  </div>
                  <div class="test-item">
                    <div class="progress-container">
                      <div class="main-progress">
                        <div
                          class="current-marker"
                          :style="markerPosition(BmiData)"
                        ></div>
                      </div>
                    </div>
                    <div class="reference-bar">
                      <div
                        class="segment"
                        v-for="(seg, index) in getSegments(BmiData)"
                        :key="index"
                      >
                        <div
                          class="marker"
                          :style="segmentStyle(seg, BmiData)"
                        ></div>
                        <span class="label">{{ seg.label }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 成绩列表 -->
        <div class="projectBox" v-show="projectScoreList.length > 0">
          <div class="project_titleBox">
            体测成绩 <span style="font-size: 12px"></span>
          </div>
          <div
            v-for="(item, i) in projectScoreList"
            :key="i"
            class="project_li"
          >
            <div class="project_title">{{ item.projectName || "" }}</div>
            <div v-if="item.score !== '未测试'">
              <div class="project_score">
                <div
                  class="project_score_li"
                  v-if="item.projectCode === 'HeightWeight'"
                >
                  <div class="project_score_li_top">
                    {{ item.value || "--" }}
                  </div>
                  <div class="project_score_li_bottom">BMI</div>
                </div>
                <div class="project_score_li" v-else>
                  <div class="project_score_li_top">
                    {{ item.fraction || "--" }}
                  </div>
                  <div class="project_score_li_bottom">得分</div>
                </div>
                <div class="project_score_li">
                  <div class="project_score_li_top">{{ item.score }}</div>
                  <div class="project_score_li_bottom">成绩</div>
                </div>
                <div class="project_score_li">
                  <div class="project_score_li_top">{{ item.level }}</div>
                  <div class="project_score_li_bottom">等级</div>
                </div>
              </div>
              <div class="project_video">
                <div style="color: #333333" class="dfcenter">
                  <img
                    src="@/assets/image/奖杯@3x.png"
                    style="margin-right: 3px"
                    width="18"
                    alt=""
                  />
                  <div>
                    战胜
                    <span style="color: #333333; font-family: DINPro-Bold">{{
                      item.percent || "-"
                    }}</span>
                    %的同学
                  </div>
                </div>
              </div>
            </div>
            <div class="noproject_score" v-else>
              <div style="height: 60px; line-height: 60px">暂无数据</div>
            </div>
          </div>
        </div>

        <!-- 雷达图占位 -->
        <div>
          <div class="card-eachart-box">
            <div class="card-eachart" ref="physicalStrength"></div>
          </div>
          <div class="card-eachart-box">
            <div class="card-eachart" ref="physicalQuality"></div>
          </div>
        </div>

        <!-- 训练建议（简化版） -->
        <div class=" tishengbox">
          <!-- 强项拔高 -->
          <div v-if="strongItems.length > 0" class="strongItems_title">
            <span style="margin-left: 50px;">强项拔高</span>
          </div>
         
          <van-divider v-if="strongItems.length > 0" style="padding: 0 16px;margin: 10px 0;"/>
          <div v-for="item in strongItems" :key="'strong-' + item.projectCode"  class="strongItems_body">
            <div 
                style="
                font-size: 13px;
                margin: 8px 0 10px 0;
                color: #fff;
                border-radius: 8px;
                background: #6AACE2;
                width: 80px;
                height: 25px;
                line-height: 25px;
                text-align: center;
              "
            
            >
              {{ projectConfig[item.projectCode]?.name || item.projectName }}
            </div>
            <div style="font-size: 12px; color: #999">
              {{ getRandomRemark(item.projectCode, item.level) }}
            </div>
            <div
              style="
                font-size: 13px;
                margin: 15px 0;
                border-radius: 8px;
                width: 80px;
                height: 25px;
                line-height: 25px;
                text-align: center;
              "
            >
             <span style="color: #6AACE2; margin-right: 4px;">●</span>训练方法
            </div>
            <div >
              <div
              v-for="(train, idx) in getTrainings(item.projectCode)"
              :key="idx"
              style="font-size: 13px; margin: 16px 0 6px 0;margin-right: 10px;"
            >
              ({{ idx + 1 }}) {{ train }}
            </div>
            </div>
          </div>

          <div
            style="margin-bottom: 30px"
            v-if="strongItems.length > 0 && weakItems.length > 0"
          ></div>

          <!-- 弱项提升 -->
          <div v-if="weakItems.length > 0"  class="weakItems_title">
            <span style="margin-left: 50px;">弱项提升</span>
            </div>
       
          <van-divider v-if="weakItems.length > 0"  style="padding: 0 16px;margin: 10px 0;"/>
   <div v-for="item in weakItems" :key="'weak-' + item.projectCode"  class="strongItems_body">
            <div 
                style="
                font-size: 13px;
                margin: 8px 0 10px 0;
                color: #fff;
                border-radius: 8px;
                background: #75D29B;
                width: 80px;
                height: 25px;
                line-height: 25px;
                text-align: center;
              "
            
            >
              {{ projectConfig[item.projectCode]?.name || item.projectName }}
            </div>
            <div style="font-size: 12px; color: #999">
              {{ getRandomRemark(item.projectCode, item.level) }}
            </div>
            <div
              style="
                font-size: 13px;
                margin: 15px 0;
                border-radius: 8px;
                width: 80px;
                height: 25px;
                line-height: 25px;
                text-align: center;
              "
            >
             <span style="color: #75D29B; margin-right: 4px;">●</span>训练方法
            </div>
            <div >
              <div
              v-for="(train, idx) in getTrainings(item.projectCode)"
              :key="idx"
              style="font-size: 13px; margin: 16px 0 6px 0;margin-right: 10px;"
            >
              ({{ idx + 1 }}) {{ train }}
            </div>
            </div>
          </div>

      
        </div>

        <!-- 底部 -->
        <div class="bottom-box">
          <div class="qrcode-section">
            <h3>扫码关注获取更多健康建议</h3>
            <vue-qr
              :text="qrCodeUrl"
              :dotScale="0.55"
              colorDark="#000"
              colorLight="#fff"
              :size="80"
              :margin="5"
            ></vue-qr>
            <p class="qrcode-desc">微信扫码关注「龙猫中小学体育服务平台」</p>
          </div>
          <div class="report-footer">
            © 参考男性16岁身体素质进行分析 | 本报告仅用于健康参考
          </div>
        </div>
      </div>
    </div>

    <!-- 生成长图悬浮按钮 -->
    <div class="fab-container">
      <button @click="generateImage" :disabled="generating" class="fab-button">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V9L14 3Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 3V9H20"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 13H16.01"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 17H16.01"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 13H12.01"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 17H12.01"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 13H8.01"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 17H8.01"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import vueQr from "vue-qr";
import * as echarts from "echarts";

// 雷达图1：运动体能（7项）
const physicalStrength = {
  indicator: [
    { name: "形态", max: 5 },
    { name: "灵敏性", max: 5 },
    { name: "上肢力量", max: 5 },
    { name: "下肢力量", max: 5 },
    { name: "协调性", max: 5 },
    { name: "柔韧性", max: 5 },
    { name: "平衡性", max: 5 },
  ],
  data: ["形态", "灵敏性", "上肢", "下肢", "协调", "柔韧", "平衡"],
};

// 雷达图2：身体素质（8项）
const physicalQuality = {
  indicator: [
    { name: "速度", max: 5 },
    { name: "耐力", max: 5 },
    { name: "柔韧", max: 5 },
    { name: "灵敏", max: 5 },
    { name: "上肢力量", max: 5 },
    { name: "下肢力量", max: 5 },
    { name: "核心力量", max: 5 },
    { name: "BMI", max: 5 },
  ],
  data: ["速度", "耐力", "柔韧", "灵敏", "上肢", "下肢", "核心", "BMI"],
};
export default {
  name: "BodyTestReport",
  components: { vueQr },
  data() {
    return {
      params: {},
      generating: false,
      student: { name: "", gender: "男", age: 16 },
      qrCodeUrl:
        "http://nh5.xtotoro.com/whitePage/TouristBind?snCode=lmwzTest0010&schoolCode=LMWZ",
      BmiData: {
        height: "",
        weight: "",
        value: "",
        level: "",
        standards: ["18.5", "24", "28"],
      },
      finalScoreData: {
        finalWeightScore: 0,
        level: "未测试",
      },
      levels: ["低体重", "正常", "超重", "肥胖"],
      projectScoreList: [],
      // 评分标准（按性别+年龄分组）
      standardConfig: {
        PullUp: {
          male: { junior: [3, 6, 9], senior: [5, 9, 13], college: [6, 11, 13] },
          female: { junior: [1, 2, 3], senior: [2, 3, 4], college: [2, 3, 4] },
        },
        Jump: {
          male: {
            junior: [160, 190, 220],
            senior: [180, 210, 240],
            college: [185, 225, 240],
          },
          female: {
            junior: [130, 160, 190],
            senior: [140, 170, 200],
            college: [150, 190, 205],
          },
        },
        SitAndReach: {
          male: {
            junior: [3, 10, 15],
            senior: [5, 13, 18],
            college: [-0.2, 13.8, 17.8],
          },
          female: {
            junior: [5, 12, 18],
            senior: [7, 15, 20],
            college: [8.8, 18.8, 22.8],
          },
        },
        VitalCapacity: {
          male: {
            junior: [1800, 2500, 3200],
            senior: [2500, 3500, 4200],
            college: [2300, 3500, 4000],
          },
          female: {
            junior: [1200, 1800, 2400],
            senior: [1800, 2500, 3200],
            college: [1800, 2500, 3000],
          },
        },
        FiftyMeters: {
          male: {
            junior: [9.5, 8.0, 7.5],
            senior: [9.0, 7.8, 7.4],
            college: [9.9, 7.9, 7.6],
          },
          female: {
            junior: [10.0, 8.5, 8.0],
            senior: [9.5, 8.2, 7.8],
            college: [10.5, 8.5, 8.2],
          },
        },
      },
      // 运动建议分析
      projectRemarkMap: {
        // 坐位体前屈 (SitAndReach)
        SitAndReach: {
          优秀: [
            "“孩子的柔韧性表现非常出色！成绩远超优秀线，这表明他的关节和肌肉非常放松且有弹性。如此好的身体条件，非常适合舞蹈、体操或武术等运动。请继续保持日常的拉伸习惯，让这个优势成为你的闪光点！”",
            "“太棒了！你的柔韧性是顶尖水平，推得很远，动作也非常标准。这能有效帮助你预防运动损伤。可以考虑挑战一些更高难度的拉伸动作，或者成为班里的小老师，帮助同学们一起进步！”",
            "“完美的柔韧性成绩！这绝非一日之功，肯定与你平时的活动和拉伸习惯分不开。这项能力会让你在许多运动中感到更加轻松自如。坚持下去，让它成为你一生的健康财富。",
          ],
          良好: [
            "“孩子的柔韧性达到良好水平，非常不错！说明身体有一定的柔软度。如果我们再每天花上5分钟，比如在看电视时双腿伸直用手去够脚尖，感受到微微拉伸感即可，很快就能看到自己突破到‘优秀’区！”",
            "“成绩良好，很有潜力！现在距离优秀只有一点点距离。突破口在于坚持：每天睡前做3组‘坐位体前屈’，每组尽力保持15秒，记录每天的成绩，你会发现每周都在进步！”",
            "“良好的柔韧性是健康体态的基础。你的表现很不错！如果想更上一层楼，可以试试‘站立体前屈’动作，放松你的背部和大腿后侧。这个小改变会带来大不同，加油！”",
          ],
          及格: [
            "“孩子完成了测试，达到了合格线。柔韧性有非常大的提升空间，现在可能会感觉腿后侧比较紧。别担心，这是很多同龄人的情况。建议每天洗澡后，肌肉暖和时，坐在地上轻轻向前够，比赛看谁先摸到脚尖，让拉伸变得有趣起来！”",
            "“成绩合格，我们有了一个很好的起点！柔韧性提升的关键是‘循序渐进’。从现在开始，每天做两次‘蝴蝶式’拉伸（脚心相对，膝盖下压），每次30秒，坚持两周，下次测试一定会有惊喜！”",
            "“恭喜你通过了测试！柔韧性是我们需要一起关注的地方。这就像拉橡皮筋，每天拉一拉，它会越来越长。邀请爸爸妈妈一起，晚饭后做5分钟‘家庭拉伸操’，互相鼓励，共同进步！”",
          ],
          不及格: [
            "“孩子的柔韧性测试遇到了挑战，这说明我们的关节和肌肉比较紧张。这很正常，但需要我们认真对待。从现在开始，每天睡前坐在床上，双腿伸直，尽力去够脚尖，做到自己能承受的最大幅度即可，坚持是唯一的秘诀。”",
            "“我们看到在柔韧性上遇到了困难。请不要灰心，这恰恰是我们开始努力的信号！我们可以把目标拆解：第一周，目标是能让手指尖碰到脚趾；第二周，争取让手掌碰到脚背。每一点进步都值得大大表扬！”",
            "“这项成绩提醒我们，需要多关注身体的柔软度了。柔韧性差容易在运动中受伤。建议从最简单的开始：直立弯腰，放松地让手臂和头自然下垂，感受腿后侧的拉伸。每天做几次，身体会慢慢给你积极的回应。老师/爸爸妈妈会陪你一起练习！”",
          ],
        },
        // BMI (BMI)
        BMI: {
          // 注意：BMI的等级描述与其它项目不同，这里使用原始数据中的描述
          优秀: [
            "“恭喜！孩子的体重指数（BMI）完美地位于‘健康绿洲’之中，体形匀称，体格强健。这是长期坚持健康饮食和良好运动习惯的成果，你们做得非常棒！请继续保持这份平衡，让孩子茁壮成长。”",
            "“孩子的身体成分非常健康，体重和身高达到了黄金比例！这为他进行各项体育运动打下了绝佳的基础。继续享受营养均衡的三餐和丰富多彩的运动吧，这是送给孩子最好的人生礼物。”",
            "“报告显示孩子的生长状况非常理想。这得益于科学的饮食结构和充足的身体活动。请继续保持每天摄入足够的奶制品、蛋白质和蔬菜，让健康成为孩子最亲密的伙伴。”",
          ],
          良好_超重: [
            "“孩子的体重指数（BMI）稍稍超出了理想范围，但完全不必焦虑！这是一个提醒我们更加关注能量平衡的信号。”\n【建议1 - 饮品替换】：我们可以一起尝试一个最简单的改变：用白开水、无糖的柠檬水或纯牛奶，完全替代所有的含糖饮料和果汁，这是减少“隐形热量”最有效的方法。\n【建议2 - 家庭运动】：把“吃完饭看电视”的习惯，改成“晚饭后全家一起出门散步或快走20分钟”。这不仅是运动，更是珍贵的亲子时光。\n【建议3 - 健康零食】：准备一些小番茄、黄瓜条、一小把坚果作为健康的加餐选择，慢慢减少饼干、薯片等高热量零食的摄入。",
          ],
          良好_偏轻: [
            "“孩子的体型正在慢慢形成，目前稍微偏瘦一些。我们的目标不是‘胖’，而是‘壮’。”\n【建议1 - 营养加餐】：可以在上午十点和下午三点左右，各安排一次营养加餐，比如一杯酸奶、一个鸡蛋或几片全麦面包，为身体持续提供能量。\n【建议2 - 优质脂肪】：在日常饮食中，适当增加牛油果、坚果酱（抹在面包上）、橄榄油等健康脂肪的摄入，它们营养密度高，有助于健康增重。\n【建议3 - 力量型运动】：鼓励孩子多进行跳绳、游泳、骑自行车等运动，这些力量型锻炼可以刺激食欲，促进肌肉生长，让孩子变得更结实，而不是虚胖。",
          ],
          及格_超重: [
            "“孩子的体重指数（BMI）提示我们需要更多地关注他的生长发育了。目前的状态可能会让他在进行一些耐力运动时感到更容易疲劳。”\n【建议1 - 减少屏幕时间】：共同商定一个规则，将每天的看电视、玩手机/平板的时间减少30分钟，用这部分时间来进行户外活动。\n【建议2 - 改变烹饪方式】：家庭烹饪可以多采用蒸、煮、烤、凉拌的方式，替代油炸和红烧，能有效减少油脂的摄入。\n【建议3 - 设定小目标】：不要急于求成，可以和孩子一起设定一个“月度活力目标”，比如“这个月，我们一起学会踢毽子，并且能连续踢10个”，让运动的成就感替代对体重的焦虑。",
          ],
          及格_偏轻: [
            "“我们看到孩子的体格比较单薄，BMI值在合格线徘徊。健康成长需要‘营养’和‘运动’两支桨一起划。”\n【建议1 - 保证主食】：确保每一餐都有充足的主食（米饭、面条、馒头），这是身体能量的根本来源，千万不要因为吃零食而影响正餐食欲。\n【建议2 - 睡前加餐】：睡前1小时可以喝一杯温牛奶或一小碗燕麦粥，提供夜间身体生长所需的营养。\n【建议3 - 趣味运动】：找到孩子感兴趣的运动，比如打羽毛球、滑轮滑，重点是让他“动起来”，消耗能量从而产生饥饿感，形成一个“吃得香、长得壮”的良性循环。",
          ],
          不及格_肥胖: [
            "“孩子的体重指数（BMI）亮起了红灯，这需要我们高度重视并积极干预。肥胖会影响孩子的运动能力和自信心。”\n【建议1 - 立即戒断】：请立即停止购买任何含糖饮料（包括碳酸饮料、果汁饮料、奶茶等），这是必须严格执行的第一步。\n【建议2 - 寻求专业帮助】 （最重要的一条）：强烈建议咨询儿科医生或注册营养师，进行全面的身体检查，排除病理性因素，并在专业人士的指导下制定科学的饮食和运动计划，切勿自行盲目节食。\n【建议3 - 家庭共同参与】：告诉孩子：“这不是你一个人的事，我们全家会一起支持你。”全家的饮食结构都做出调整，共同参与运动，让他感到是被支持和理解的，而不是被孤立和指责的。",
          ],
          不及格_消瘦: [
            "“报告显示孩子体重明显偏轻，这可能影响他的精力和免疫力。”\n【建议1 - 医疗优先】：首要任务是带孩子去医院儿科或消化科进行检查，排除是否存在如消化吸收不良、过敏或其他潜在健康问题，这是所有行动的基础。\n【建议2 - 增加餐次】：采用“少食多餐”的原则，在三次正餐之间，增加2-3次营养加餐，减轻肠胃一次性的负担，同时增加总摄入量。\n【建议3 - 选择高营养密度食物】：在有限的食量里提供更高的营养。比如，用馄饨、饺子（有肉有菜有主食）代替单纯的面条；炒饭时加入鸡蛋、碎肉、玉米粒；牛奶中可以加入一勺蛋白粉等。",
          ],
        },
        // 50米跑 (FiftyMeters)
        FiftyMeters: {
          优秀: [
            "“真是个小飞人！孩子的50米跑成绩非常优异，起跑反应迅捷，加速果断，冲刺有力，全程节奏感十足。这出色的爆发力是许多运动项目的基础！可以多进行一些折返跑、变速跑的训练，更好地享受速度带来的激情，你在这项运动上天赋异禀！”",
            "“惊人的速度！你的起跑就像离弦之箭，后半程依然能保持强劲的动力，这体现了出色的无氧耐力。除了短跑，也非常推荐你尝试篮球、足球等需要瞬间启动和快速奔跑的运动，一定能成为场上的关键先生！”",
            "“完美的冲刺！成绩不仅优秀，更重要的是跑步姿势协调，摆臂充分，展现了很好的技术基础。继续保持你对跑步的热爱，可以尝试挑战一下校运动会，在更大的舞台上展现自己的风采！”",
          ],
          良好: [
            "“孩子50米跑的成绩良好，整体动作流畅，很有潜力！如果想更进一步，可以重点关注一下起跑：起跑时身体重心再向前倾一些，听到口令后像弹簧一样瞬间蹬出去。这个小小的技术改进，能为你赢得宝贵的0.5秒！”",
            "“成绩不错，达到了良好水平！你的途中跑节奏很稳。下一个突破点可能在摆臂：尝试在跑步时加大前后摆臂的幅度（向前摆到鼻尖高度，向后摆到腰后），并且保持手臂不要左右晃动，你会发现摆臂能为双腿提供强大的前进动力。”",
            "“良好的成绩是你努力的结果！注意到你在后程速度保持得很好，但起跑反应可以更果断。平时可以和爸爸妈妈玩‘听口令摸物’的游戏，训练听觉反应和第一时间启动的身体反应能力，让起跑不再犹豫。”",
          ],
          及格: [
            "“孩子成功完成了50米跑测试，达到了合格标准！目前的速度和力量还有很大的提升空间。我们可以把它变成有趣的游戏：比如周末在公园里设置一段20米的距离，进行计时追逐赛，多跑几次，成绩会在一次次的欢笑中不知不觉提高。”",
            "“恭喜你顺利通过测试！从跑步过程看，你的步频可以更快一些。在家可以做一些简单的练习：原地高抬腿（要求速度快）和原地小步跑，每组20秒，每天3组，能有效锻炼你的腿部交换频率，让你跑起来更轻盈。”",
            "“成绩合格，我们有了一个坚实的起点！感觉你跑步时有点紧张，不够放松。跑步时记得深呼吸，脸上保持微笑，这能神奇地帮助你放松肩部和手臂。多练习，找到轻松奔跑的感觉，速度自然就上来了。”",
          ],
          不及格: [
            "“孩子在这次50米跑中遇到了困难，可能对快速奔跑有些畏惧或尚未掌握技巧。这完全没关系！我们首先需要建立信心。从慢跑开始，重点感受跑步的乐趣，而不是速度。我们可以一起约定，每周有3天，一起慢跑5分钟，先让身体习惯和喜欢上跑步的感觉。”",
            "“成绩反映出孩子在速度能力和跑步技巧上都需要加强。请不要气馁，我们从基础开始：练习正确的摆臂姿势（前后摆，不要左右交叉）和用前脚掌着地。对着镜子练习摆臂，在草地上练习轻快的脚尖跑，打好基础是关键。”",
            "“我们看到跑步对孩子来说是一项挑战。让我们把目标分解，忘掉50米。第一步：练习反应速度，玩‘红绿灯’游戏。第二步：练习加速，从走到快走再到慢跑。第三步：练习耐力，尝试慢跑15秒不走。每完成一个小目标，都值得大大的庆祝！老师/爸爸妈妈相信你下次一定能超越自己！”",
          ],
        },
        // 立定跳远 (Jump)
        Jump: {
          优秀: [
            "“惊人的弹跳力！你的立定跳远成绩非常出色，整个动作一气呵成：蹬地迅猛有力，空中身体充分伸展，落地平稳。这出色的下肢爆发力是篮球、排球、羽毛球等运动的基石，请继续保持，你在这方面的天赋非常突出！”",
            "“你的成绩不仅远，更重要的是动作标准，摆臂和蹬地的配合恰到好处。这说明你的全身协调性非常好。可以尝试挑战原地纵跳摸高，或者连续蛙跳，看看自己的极限在哪里！”",
            "“完美的跳跃！从预备到落地，每个环节都做得无可挑剔。这绝对是长期锻炼的结果。如此强大的腿部力量能帮助你在各种运动中表现出色。希望你能保持对运动的热爱，并带动身边的小伙伴一起练习！”",
          ],
          良好: [
            "“立定跳远成绩良好，很有潜力！你的起跳很有力。如果想跳得更远，有一个小秘诀：起跳时，手臂一定要从后向前上方有力地摆动，想象自己要摸到前方高处的物品，这个‘助力’效果非常明显，下次试试看！”",
            "“成绩不错！注意到你蹬地很充分，但空中身体可以更向前“飘”，而不是向上。起跳的瞬间，眼睛要看向前上方，重心积极前移，感觉自己像要扑出去一样，这样距离会有一个大的提升。”",
            "“良好的成绩是你努力的结果！下一个突破点可能在落地技巧：落地时，膝盖要微微弯曲来缓冲，就像弹簧一样，这样可以有效保护膝盖，有时还能借助缓冲再往前一点一点哦。”",
          ],
          及格: [
            "“成功完成了立定跳远测试，达到了合格线！现在我们有了一个很好的起点。跳远的关键在于协调发力。我们可以玩一个‘小青蛙过河’的游戏：在地上画一条‘小河’，看看能不能用力跳到对岸，多跳几次，感受蹬地那一刻双腿发力弹出去的感觉。”",
            "“恭喜你通过测试！从动作看，你的摆臂可以更有力一些。起跳前，手臂先向后甩，然后跳的同时猛地向前上方甩出去，这个力量会带动你的身体向前。对着镜子练习几次摆臂，你会发现它的重要性！”",
            "“成绩合格，真棒！感觉你起跳时有点犹豫。跳远需要一点勇气。我们可以从低难度开始：先练习原地纵跳，跳起来摸家里的门框；或者从一个小台阶上跳下来，感受落地。多练习，力量和勇气会一起增长！”",
          ],
          不及格: [
            "“孩子在立定跳远中遇到了挑战，这可能是因为还没有掌握协调发力的技巧，或者腿部力量需要加强。没关系，我们一起把它变成游戏：练习小兔子跳，双脚并拢向前跳；或者学习青蛙跳，蹲下去再跳起来。这些都是在有趣地练习跳跃能力。”",
            "“成绩反映出我们在跳跃的协调性上还需要多练习。请不要灰心，我们从基础开始：重点练习摆臂和蹬地的配合。做一个‘预备-摆臂-蹬地’的分解动作练习，不追求跳多远，只追求动作做协调，熟练了再连贯起来。”",
            "“我们看到跳远对孩子来说有点难。让我们把大目标忘掉，先设定一个小目标：第一周，目标是能跳过自己的鞋子长度；第二周，目标是跳过两双鞋的长度。 每完成一个目标，都给自己一个大大的赞！重要的是你敢于尝试和努力的过程，老师/爸爸妈妈为你骄傲！”",
          ],
        },
        // 仰卧起坐 (SitUp)
        SitUp: {
          优秀: [
            "“惊人的核心力量！你的一分钟仰卧起坐成绩非常出色，动作标准流畅，节奏稳定，仿佛一台不知疲倦的小马达。这强大的腰腹力量是你运动能力的核心发动机，能让你在跑步、跳跃和各类体育活动中表现得更稳、更有力！请继续保持！”",
            "“太棒了！你的仰卧起坐不仅数量多，质量更高——每一次都标准地做到双肘触膝，充分锻炼了腹部肌肉。这体现了你出色的肌肉耐力和对自己严格的要求。如此好的核心力量，是成为运动达人的秘密武器哦！”",
            "“完美的表现！成绩优异离不开你日积月累的坚持和努力。强大的核心力量不仅能提升运动表现，更能保护你的脊柱，预防腰背疼痛。可以将平板支撑、两头起等动作加入日常训练，让你的核心堡垒更加坚固！”",
          ],
          良好: [
            "“孩子仰卧起坐的成绩良好，动作质量很不错！如果想更上一层楼，可以关注一下起身的速度：尝试在保证动作标准的前提下，稍加快起坐的节奏，但切记不要用脖子拼命发力，感受腹部收缩带动身体起来的感觉。”",
            "“成绩不错，很有潜力！注意到你后半程可能有些吃力，这是耐力需要加强的信号。我们可以采用‘间歇训练法’：用最快速度做20秒，休息10秒，再做20秒。这样分组练习，能有效提升你的腹部耐力极限。”",
            "“你的动作很标准，达到了良好水平！下一个突破点可能在呼吸的配合：记住‘起来时呼气，躺下时吸气’的节奏，正确的呼吸能为肌肉提供更多氧气，让你做得更轻松，数量自然就上去啦。”",
          ],
          及格: [
            "“成功完成了测试，达到了合格线，真为你高兴！这说明你的腹部已经有了一定的力量基础。现在，我们需要追求连续性：每天睡前在床上做2-3组，每组做到力竭为止，不计数量，目标是每一次都比上一次多做一个！”",
            "“恭喜你通过测试！从动作看，你有时会用手臂用力抱头来起身，这样脖子容易酸痛。让我们纠正一下：双手轻轻虚放在耳侧，或者交叉放在胸前，纯粹用肚子的力量把身体‘卷’起来，感受腹部的燃烧感！”",
            "“成绩合格，这是一个坚实的起点！腰腹力量是我们需要一起加强的地方。我们可以把它变成亲子游戏：和爸爸妈妈比赛‘谁做得快’，或者练习‘仰卧举腿’（平躺向上抬腿）来锻炼下腹部。坚持下去，力量会越来越强！”",
          ],
          不及格: [
            "“孩子在这次测试中遇到了困难，可能还没有找到腹部发力的感觉，或者核心力量比较薄弱。没关系，我们从最基础的开始：练习‘仰卧卷腹’——只需要平躺，膝盖弯曲，努力让肩膀离地即可，感受肚子的收缩，这是仰卧起坐的核心动作。”",
            "“成绩反映出我们的腰腹力量需要重点加强。请不要灰心，力量增长需要时间。我们可以做辅助练习：请爸爸妈妈轻轻压住你的脚背，给你一个向上的支点；或者从斜板仰卧起坐（头高脚低）开始，利用重力减小难度。”",
            "“我们看到完成完整的仰卧起坐对孩子来说很有挑战。让我们分解目标：第一周，目标是能标准地完成5个；第二周，目标10个。每完成一个，都是巨大的进步！更重要的是培养运动习惯，每天花5分钟练习，老师/爸爸妈妈相信你很快就能看到自己的改变！”",
          ],
        },
        // 引体向上 (PullUp)
        PullUp: {
          优秀: [
            "“太出色了！你的引体向上成绩令人惊叹，每一次上拉都下颌过杠，下放时手臂完全伸直，动作标准且有力。这展现了惊人的上肢和背部力量，这绝对是长期坚持锻炼的结果！这份力量会让你在攀爬、游泳等所有需要克服自身体重的运动中充满优势。”",
            "“了不起的上肢力量！你完成引体向上时身体稳定，没有多余的摆动，全靠肌肉力量拉升，这是最高水平的体现。如此强大的相对力量，是体魄强健的最佳证明。可以尝试挑战更宽握距或颈后引体，给你的肌肉新的刺激！”",
            "“完美！你的引体向上不仅数量多，而且节奏控制得非常好，这说明你的肌肉耐力和控制力都达到了极高水准。请继续保持这份热爱和坚持，你已经成为许多同学心目中的‘力量标杆’了！”",
          ],
          良好: [
            "“非常棒！你能完成多个标准引体向上，达到了良好水平，这已经超越了大部分同龄人！如果想突破到优秀级别，可以关注发力技巧：感受背部肩胛骨收紧、带动身体向上的感觉，而不仅仅是用手臂硬拉，这样会更省力，做得更多。”",
            "“成绩很好，很有潜力！注意到你在后几个动作时可能会借助身体的摆动。下一步的突破点在于增强耐力：尝试‘力竭训练法’，做到一个都做不了为止，记录每次的总数，挑战自己不断突破极限。”",
            "“你的引体向上基础非常扎实！提升的关键可能在于增加训练频率：不必每次做到力竭，可以每天做2-3组，每组做最大数量的70%，这种‘高频低量’的方式能更好地建立肌肉神经联系和耐力。”",
          ],
          及格: [
            "“恭喜你！成功完成了引体向上测试，这本身就是一个巨大的胜利！这说明你已经具备了最基础的上肢拉力。现在，我们的目标是从1个到多个：继续保持练习，可以请同学辅助托一下腰，或者在脚下垫一个弹力带借力，帮助自己完成更多次数。”",
            "“太好了！你已经成功克服了自重，完成了引体向上！目前数量还在积累阶段。建议进行辅助训练：重点练习‘悬垂’（尽可能长时间挂在单杠上）和‘离心下降’（跳起来到最高点，然后用尽全力控制身体慢慢下降），这两个动作能飞速增长你的力量。”",
            "“成绩合格，这是一个从0到1的质变，值得大大表扬！接下来，我们需要全面发展拉力肌群：除了练单杠，在家可以多做‘划船’动作（用弹力带或矿泉水瓶模仿划船），强化你的背部肌肉，这是引体向上的主要发动机。”",
          ],
          不及格: [
            "“孩子在引体向上测试中未能完成，这非常正常，这是中小学阶段最具挑战的项目之一。这告诉我们，上肢和背部力量是我们接下来要共同努力的目标。请不要灰心，我们从‘悬垂’开始，目标是能稳稳地挂在单杠上10秒钟，感受手臂和背部的发力。”",
            "“成绩反映出我们的上肢相对力量比较薄弱。我们不需要气馁，从退阶动作开始练习是最好的方法：第一步，练习‘斜身引体’（在低单杠下，身体斜着做）；第二步，使用弹力带辅助；第三步，尝试‘跳跃引体’，跳起来借助惯性完成上拉。每一步都是进步！”",
            "“我们看到这个项目对孩子来说非常困难。让我们完全抛开‘从零开始’的焦虑，我们的初始目标不是‘拉上去’，而是‘建立力量’。每天尝试做‘俯卧撑’来锻炼推力（这对拉力也有帮助），或者用重物练习‘弯举’和‘划船’。力量是基础，只要坚持，某一天你一定能惊喜地把自己拉起来！老师/爸爸妈妈相信你！”",
          ],
        },
        // 跳绳 (RopeSkipping)
        RopeSkipping: {
          优秀: [
            "“太厉害了！你跳绳时就像一只轻盈的小鹿，手脚配合天衣无缝，节奏快且稳，几乎零失误！这出色的表现不仅需要协调性，更需要强大的心肺耐力支撑。你可以挑战更有趣的花样跳绳，如双摇、交叉跳，成为学校的跳绳小明星！”",
            "“完美的节奏大师！你的一分钟跳绳成绩优异，这说明你拥有极佳的身体协调性和节奏感。跳绳是一项完美的全身运动，请坚持跳下去，它会让你的身体更加灵敏、强壮。不妨尝试听着音乐跳，享受韵律与运动结合的美妙。”",
            "“惊人的耐力与技巧！成绩远超优秀线，背后一定付出了许多汗水。你的手腕摇绳动作非常标准，这是跳得又快又省力的关键。如此强的协调能力，让你在学习其他运动，如舞蹈、体操时也会事半功倍！”",
          ],
          良好: [
            "“孩子跳绳跳得很棒，节奏感很好，达到了良好水平！如果想冲击优秀，关键可能在于减少中途的失误。可以尝试设定一个小目标：练习‘连续跳50个不停’，专注于身体的稳定和摇绳的均匀，一旦连续性上去，成绩会大幅提升。”",
            "“成绩良好，非常有潜力！注意到你中途会有几次停顿。这可能是体力分配或专注度的问题。我们可以采用‘分段法’：用最快的速度跳前30秒，建立数量优势；中间20秒稳住节奏；最后10秒全力冲刺。试试这个策略！”",
            "“你的跳绳动作很协调，成绩不错！下一个突破点可能在手腕的灵活性：尝试跳得更高一些，同时加快手腕摇绳的圈速，让绳子的转动更快，从而在相同时间内增加次数。记住，是用手腕摇，而不是整个胳膊哦。”",
          ],
          及格: [
            "“成功完成了一分钟跳绳测试，真为你高兴！目前成绩达到了合格标准，说明我们已经掌握了基本的跳跃和摇绳配合。提升的秘诀在于多练，建立肌肉记忆。每天课后跳3组，每组1分钟，不计数量只求不停，你会发现一周后就能连跳很多个了！”",
            "“恭喜你通过测试！从过程看，你可能是用手臂大力摇绳，所以容易累。让我们练习用腕发力：把手肘贴在身体两侧，只用手腕画小圈摇绳。可以先做‘无绳空跳’练习动作，感受正确发力，再拿起绳子。”",
            "“成绩合格，这是一个很好的开始！跳绳的节奏感正在慢慢形成。我们可以把它变得更有趣：听着有节奏感的儿歌或音乐来跳，让身体自然跟随节拍；或者和爸爸妈妈比赛‘谁连续跳得多’，在游戏中轻松进步。”",
          ],
          不及格: [
            "“孩子在跳绳测试中遇到了不小的困难，这可能是因为手脚的协调配合还在摸索中。这非常正常！我们首先需要建立自信。从‘分解动作’开始：第一步，不用绳，练习双脚同时起跳落地；第二步，单手摇绳，跳过去；第三步，再尝试连贯起来。每步做好都值得表扬！”",
            "“成绩反映出我们在手脚协同和节奏感上需要加强。请不要灰心，我们从零开始。最好的练习是‘辅助摇绳’：由爸爸妈妈帮你摇绳，你只需要听口令跳过去，先专注于‘跳’这个动作，熟练后再自己尝试摇跳结合。”",
            "“我们看到跳绳对孩子来说是一个挑战。让我们把目标降到最低，从成功跳过一个开始，重点感受‘跳过去’的成就感。还可以练习原地纵跳来增强腿部力量。请记住，敢于尝试就是最大的成功，我们一步一步来，老师/爸爸妈妈会一直为你加油！”",
          ],
        },
        // 800/1000米跑 (EnduranceRun)
        EnduranceRun: {
          优秀: [
            "“太令人赞叹了！你的耐力跑成绩非常出色，全程节奏稳定，呼吸均匀，甚至在最后阶段还能有力冲刺。这强大的心肺功能是你身体健康最坚实的基石，更难得的是，你展现了超越常人的坚持和毅力！这份品质会让你在未来任何挑战中都无所畏惧。”",
            "“你是一位真正的耐力型选手！不仅成绩优异，更重要的是你跑步的姿态和节奏控制都显得非常老练，懂得合理分配体力。这绝对是长期锻炼和强大自律的结果。可以尝试挑战更长距离（如5公里慢跑），享受耐力运动带来的成就感和愉悦感。”",
            "“完美地征服了跑道！你的表现堪称典范。如此出色的有氧耐力，意味着你的心脏非常强健，能高效地为身体供能。请继续保持跑步的习惯，它是你送给未来自己最好的一份健康礼物。你是同学们的榜样！”",
          ],
          良好: [
            "“非常棒！你顺利完成了耐力跑测试，并且取得了良好的成绩！你的整体节奏保持得不错。如果想跑得更轻松、成绩更好，可以重点关注一下呼吸的节奏：尝试‘两步一吸，两步一呼’（或三步），找到并保持自己最舒适的呼吸频率，这是耐力跑的关键秘诀。”",
            "“成绩良好，你已经成功战胜了跑道！注意到你在中途可能感到非常疲劳，但你还是坚持下来了，这本身就是胜利。下一个突破点可能在速度分配：起跑时一定要克制住，用你觉得‘稍慢’的速度开始，为后半程保存体力，你会发现最后能超越很多人。”",
            "“你坚持跑完了全程，成绩良好，为你点赞！后半程的坚持充分体现了你的意志力。提升的关键在于日常积累：每周进行2-3次轻松的慢跑（不计时，能边跑边说话的程度），每次15-20分钟，慢慢你的耐力就会在不知不觉中增长。”",
          ],
          及格: [
            "“恭喜你！你用自己的坚持和汗水，成功抵达了终点！完成耐力跑本身就是一项巨大的成就。现在，我们的目标是跑得更轻松：下次练习时，试着找到和自己速度差不多的同学一起跑，互相鼓励和陪伴，你会发现时间过得快很多。”",
            "“你成功挑战了自己，真了不起！跑步的过程可能非常辛苦，但你没有放弃。建议我们从跑走结合开始：制定一个小计划，比如跑一圈走一分钟，慢慢减少走的时间，增加跑的时间，循序渐进地提升我们的耐力。”",
            "“成绩合格，这意味着你拥有了基础的心肺耐力！现在我们需要培养兴趣：不要为了跑步而跑步。可以尝试在跑步时听听喜欢的音乐或有声故事；或者周末去公园、绿地慢跑，欣赏风景，让跑步变成一种享受而不是任务。”",
          ],
          不及格: [
            "“孩子在耐力跑中遇到了极大的挑战，可能感到呼吸困难、肌肉酸痛甚至想要放弃。这非常正常，这说明我们的心肺系统和肌肉耐力需要更多的锻炼。请千万不要因此讨厌跑步，我们从‘快走’开始，目标是每周有3天，进行20分钟的愉快快走，让身体先动起来。”",
            "“成绩反映出我们的体能基础比较薄弱。这没关系，每个人的起点不同！我们不需要跑，我们的第一个目标是连续快走完成全程。走完后如果觉得还有力气，可以尝试慢跑50米。重要的是参与和坚持，每一次完成都是百分百的胜利。”",
            "“我们看到这个项目对孩子来说非常艰难。让我们彻底放下对速度和距离的要求。我们的唯一目标是：穿上运动鞋，站上跑道，并尽自己最大的努力完成它。无论结果是走是跑，无论名次如何，只要你没有中途退场，你就是最棒的！老师/爸爸妈妈为你感到骄傲，我们一起慢慢来，体能一定会越来越好！”",
          ],
        },
        // 肺活量 (VitalCapacity)
        VitalCapacity: {
          优秀: [
            "“真令人惊叹！你的肺活量测试成绩非常出色，远远超过了优秀线！这意味你的‘身体小发动机’——心肺功能非常强大，能为你的学习和运动提供源源不断的能量。如此好的基础，一定要保持下去，继续享受运动带来的活力吧！”",
            "“你的成绩表明你的肺容量大，呼吸肌肉充满力量。这不仅让你在跑步、游泳时更轻松，也能让你在唱歌、吹奏乐器时更有优势。这说明你平时一定经常进行体育锻炼，请坚持下去！”",
            "“强大的肺功能是健康体魄的核心指标之一，代表着你身体摄氧和利用氧气的效率极高。继续保持你热爱运动的好习惯，这会让你的身体始终保持在最佳状态。”",
          ],
          良好: [
            "“非常不错！你的肺活量达到了良好水平，这说明你的心肺功能基础很扎实。如果我们想挑战一下‘优秀’，可以尝试一些增强呼吸深度的游戏：比如每天做几次‘闻花香’式的深吸气（感觉腹部鼓起），然后像‘吹蜡烛’一样缓慢均匀地呼气，让肺部得到充分扩张。”",
            "“成绩良好，很有潜力！你的肺活量还有提升空间。提升的关键在于坚持有氧运动：像跳绳、慢跑、骑自行车这类运动，能像给肺部做体操一样，让它变得更加强壮有力。每周坚持3次，很快就能看到变化。”",
            "“你的肺活量表现很好！下一个突破点可能在呼吸技巧：测试时，先深深地吸一大口气，吸到不能再吸为止，吹的时候不要一下子猛吹完，要持续、均匀、缓慢地用力，把最后一口气都推出来，这样成绩会更好哦。”",
          ],
          及格: [
            "“恭喜你，顺利通过了肺活量测试！这是一个很好的开始，说明我们的肺部‘基本功’是OK的。现在，我们的目标是让肺部‘扩容’：每天睡前或起床后，做5次深呼吸练习，尽量吸得深、呼得尽，简单又有效。”",
            "“成功完成测试，真棒！成绩合格意味着我们有了提升的坚实基础。我们可以把锻炼融入生活：多进行一些户外活动，比如在公园里追逐跑、放风筝，在大自然中呼吸新鲜空气，本身就是对肺部的良好锻炼。”",
            "“成绩达标了，真为你高兴！肺活量就像肌肉，越练越大。我们可以做一些有趣的气息游戏：比如吹桌子上的乒乓球，看谁吹得远；或者练习吹肥皂泡，看谁吹得大。这些都能在玩乐中不知不觉锻炼肺活量。”",
          ],
          不及格: [
            "“孩子在肺活量测试中成绩不太理想，这可能是因为还没有掌握正确的吹气方法，或者呼吸肌力量比较弱。没关系，我们从学习深呼吸开始：把手放在肚子上，吸气时感觉肚子像气球一样鼓起来，呼气时瘪下去，每天练习几分钟。”",
            "“成绩反映出我们的肺部力量需要加强。这很正常，只要我们开始练习就会进步！最好的方法是多进行全身性的有氧运动，比如快走、慢跑、跳绳。运动时身体需要更多氧气，自然会督促肺部‘努力工作’，变得更强壮。”",
            "“我们看到肺活量是一个需要加强的领域。请千万不要有压力，我们可以把它当成一个游戏。第一个小目标：每天吹一次肺活量测试仪（如果有），或者折一个风车用力吹气，看看它能转多久。我们的目标是比昨天多吹一秒钟！重要的是快乐地参与，你的肺活量一定会一天比一天大。”",
          ],
        },
      },
      projectConfig: {
        PullUp: {
          name: "上肢力量",
          remarks: "", 
          trainings: ["哑铃前平举", "哑铃推举", "引体向上辅助训练"],
        },
        Jump: {
          name: "下肢爆发力",
          remarks: "", 
          // remarks: this.projectRemarkMap.Jump,
          trainings: ["纵跳摸高", "蛙跳", "跳台阶"],
        },
        SitAndReach: {
          name: "柔韧性",
          remarks: "", 
          // remarks: this.projectRemarkMap.SitAndReach,
          trainings: ["一字马", "压腿", "弓步下压"],
        },
        FiftyMeters: {
          name: "速度",
          remarks: "", 
          // remarks: this.projectRemarkMap.FiftyMeters,
          trainings: ["起跑反应训练", "高抬腿", "折返跑"],
        },
        VitalCapacity: {
          name: "心肺功能",
          remarks: "", 
          // remarks: this.projectRemarkMap.VitalCapacity,
          trainings: ["深呼吸练习", "慢跑", "跳绳"],
        },
        // 可继续添加其他项目
      },
      strongItems: [],
      weakItems: [],
    };
  },
  created() { 
    this.parseUrlParams();
  },
  async mounted() {
    console.log(111111111,this.projectRemarkMap.PullUp);
    
    this.buildReport();
    this.analyzeStrengthsAndWeaknesses();
    const { strengthData, qualityData } = this.buildRadarData(this.params);

    // 渲染雷达图1
    this.getPhysicalStrength(
      ["综合评估"],
      [
        { name: "形态", max: 5 },
        { name: "灵敏性", max: 5 },
        { name: "上肢力量", max: 5 },
        { name: "下肢力量", max: 5 },
        { name: "协调性", max: 5 },
        { name: "柔韧性", max: 5 },
        { name: "平衡性", max: 5 },
      ],
      [{ name: "综合评估", value: strengthData, data: strengthData }]
    );

    // 渲染雷达图2
    this.$nextTick(() => {
      this.getPhysicalQuality(
        ["身体素质"],
        [
          { name: "速度", max: 5 },
          { name: "耐力", max: 5 },
          { name: "柔韧", max: 5 },
          { name: "灵敏", max: 5 },
          { name: "上肢力量", max: 5 },
          { name: "下肢力量", max: 5 },
          { name: "核心力量", max: 5 },
          { name: "BMI", max: 5 },
        ],
        [{ name: "身体素质", value: qualityData, data: qualityData }]
      );
    });
  },
  methods: {
    // BMI 评分（1~5）
    getBmiScore(bmi) {
      if (bmi < 18.5) return 2; // 低体重
      if (bmi <= 24) return 5; // 正常
      if (bmi <= 28) return 3; // 超重
      return 1; // 肥胖
    },

    // 引体向上评分（男生）
    getPullUpScore(score, gender, age) {
      if (gender !== "男") return 3;
      if (score >= 13) return 5;
      if (score >= 11) return 4;
      if (score >= 6) return 3;
      if (score >= 3) return 2;
      return 1;
    },

    // 立定跳远评分
    getJumpScore(score, gender, age) {
      const isMale = gender === "男";
      const standard = isMale ? 240 : 200; // 优秀线
      if (score >= standard) return 5;
      if (score >= standard * 0.9) return 4;
      if (score >= standard * 0.8) return 3;
      if (score >= standard * 0.7) return 2;
      return 1;
    },

    // 坐位体前屈评分
    getSitReachScore(score, gender, age) {
      const isMale = gender === "男";
      const standard = isMale ? 17.8 : 22.8; // 优秀线
      if (score >= standard) return 5;
      if (score >= standard * 0.9) return 4;
      if (score >= standard * 0.8) return 3;
      if (score >= standard * 0.7) return 2;
      return 1;
    },

    // 50米跑评分（越小越好）
    getFiftyScore(time, gender, age) {
      const isMale = gender === "男";
      const standard = isMale ? 7.6 : 8.2; // 优秀线（秒）
      if (time <= standard) return 5;
      if (time <= standard * 1.1) return 4;
      if (time <= standard * 1.2) return 3;
      if (time <= standard * 1.3) return 2;
      return 1;
    },
    // 根据 URL 参数生成雷达图数据
    buildRadarData() {
      const { gender, age } = this.student;
      const scores = this.rawScores;

      // 1~5 分评分（基于 0-100 分）
      const getRadarScore = (projectCode, value) => {
        const { fraction } = this.evaluateProject(projectCode, value);
        if (fraction >= 90) return 5;
        if (fraction >= 80) return 4;
        if (fraction >= 60) return 3;
        if (fraction >= 40) return 2;
        return 1;
      };

      const upper = getRadarScore("PullUp", scores.PullUp || 0);
      const lower = getRadarScore("Jump", scores.Jump || 0);
      const flexibility = getRadarScore("SitAndReach", scores.SitAndReach || 0);
      const speed = getRadarScore("FiftyMeters", scores.FiftyMeters || 10);
      const vital = getRadarScore("VitalCapacity", scores.VitalCapacity || 0);

      const bmiScore = this.getBmiRadarScore(scores.height, scores.weight);
      const defaultScore = 3;

      return {
        strengthData: [
          bmiScore,
          defaultScore,
          upper,
          lower,
          defaultScore,
          flexibility,
          defaultScore,
        ],
        qualityData: [
          speed,
          vital,
          flexibility,
          defaultScore,
          upper,
          lower,
          defaultScore,
          bmiScore,
        ],
      };
    },
    // 替换你原有的 calculateLevel 和 calculateFraction
    evaluateProject(projectCode, score) {
      const { gender, age } = this.student;
      const isMale = gender === "男";
      const ageGroup = this.getAgeGroup(age);
      const standard =
        this.standardConfig[projectCode]?.[isMale ? "male" : "female"]?.[
          ageGroup
        ];

      // 特殊处理：女生无引体向上
      if (projectCode === "PullUp" && !isMale) {
        return { level: "未测试", fraction: 0, percent: 0 };
      }

      if (!standard) {
        return { level: "未测试", fraction: 0, percent: 0 };
      }

      const isTime = projectCode === "FiftyMeters"; // 跑步类：越小越好
      let level = "不及格";
      let fraction = 50;

      if (isTime) {
        if (score <= standard[2]) {
          level = "优秀";
          fraction = 95;
        } else if (score <= standard[1]) {
          level = "良好";
          fraction = 85;
        } else if (score <= standard[0]) {
          level = "及格";
          fraction = 70;
        }
      } else {
        if (score >= standard[2]) {
          level = "优秀";
          fraction = 95;
        } else if (score >= standard[1]) {
          level = "良好";
          fraction = 85;
        } else if (score >= standard[0]) {
          level = "及格";
          fraction = 70;
        }
      }

      const percent = Math.min(95, Math.max(30, fraction - 5));
      return { level, fraction, percent };
    },
    getBmiRadarScore(height, weight) {
      if (!height || !weight) return 3;
      const bmi = weight / (height / 100) ** 2;
      if (bmi < 18.5) return 2;
      if (bmi <= 24) return 5;
      if (bmi <= 28) return 3;
      return 1;
    },
    getPhysicalQuality(legend, indicator, series) {
      const myChart = echarts.init(this.$refs.physicalQuality);
      const option = {
        title: {
          text: "身体素质分析",
          textStyle: {
            fontSize: 16,
            fontWeight: 500,
          },
        },
        legend: {
          data: legend,
          left: "right",
          top: 0,
          orient: "vertical",
        },
        radar: {
          indicator: indicator,
          center: ["50%", "60%"],
          radius: 90, // 雷达图缩放大小
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            areaStyle: {},
            data: series,
          },
        ],
      };

      if (option && typeof option === "object") {
        myChart.setOption(option);
      }
      window.addEventListener("resize", myChart.resize);
    },
    getPhysicalStrength(legend, indicator, series) {
      const myChart = echarts.init(this.$refs.physicalStrength);
      const option = {
        //  color: ['#13befc','#23befc'],

        title: {
          text: "运动体能数据综合分析",
          textStyle: {
            fontSize: 16,
            fontWeight: 500,
          },
        },
        legend: {
          data: legend,
          left: "right",
          top: 0,
          orient: "vertical",
        },
        radar: {
          indicator: indicator,
          center: ["50%", "60%"],
          radius: 90, // 雷达图缩放大小
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            areaStyle: {},
            data: series,
          },
        ],
      };

      if (option && typeof option === "object") {
        myChart.setOption(option);
      }

      window.addEventListener("resize", myChart.resize);
    },
    parseUrlParams() {
      const params = new URLSearchParams(window.location.search);
      this.student = {
        name: "学生",
        gender: params.get("gender") || "男",
        age: parseInt(params.get("age")) || 16,
        snCode: params.get("snCode") || "lmwzTest0010",
        schoolCode: params.get("schoolCode") || "LMWZ",
      };
      // 提取体测项目
      const scores = {};
      for (const [key, value] of params) {
        if (["gender", "age", "name"].includes(key)) continue;
        scores[key] = parseFloat(value);
      }
      this.rawScores = scores;
      this.params = { ...this.student, ...scores };
      this.qrCodeUrl=`http://nh5.xtotoro.com/whitePage/TouristBind?snCode=${this.student.snCode}&schoolCode=${this.student.schoolCode}`

      
    },

    getAgeGroup(age) {
      if (age <= 14) return "junior";
      if (age >= 15 && age <= 17) return "senior";
      return "college";
    },

    getStandard(projectCode) {
      const gender = this.student.gender === "女" ? "female" : "male";
      const ageGroup = this.getAgeGroup(this.student.age);
      return this.standardConfig[projectCode]?.[gender]?.[ageGroup] || null;
    },

    buildReport() {
      const projectMap = {
        PullUp: "引体向上",
        Jump: "立定跳远",
        SitAndReach: "坐位体前屈",
        VitalCapacity: "肺活量",
        FiftyMeters: "50米跑",
        HeightWeight: "BMI",
      };

      // 处理 BMI
      const height = this.rawScores.height;
      const weight = this.rawScores.weight;
      if (height && weight) {
        const bmi = (weight / (height / 100) ** 2).toFixed(1);
        let bmiLevel = "正常";
        if (bmi < 18.5) bmiLevel = "低体重";
        else if (bmi <= 24) bmiLevel = "正常";
        else if (bmi <= 28) bmiLevel = "超重";
        else bmiLevel = "肥胖";
        this.BmiData = {
          height,
          weight,
          value: bmi,
          level: bmiLevel,
          standards: ["18.5", "24", "28"],
        };
      }

      // 构建项目列表
      const list = [];
      for (const [code, score] of Object.entries(this.rawScores)) {
        if (["height", "weight"].includes(code)) continue;
        if (!projectMap[code]) continue;

        const { level, fraction, percent } = this.evaluateProject(code, score);
        list.push({
          projectCode: code,
          projectName: projectMap[code],
          score: code === "FiftyMeters" ? `${score.toFixed(1)} 秒` : score,
          level,
          fraction,
          percent,
          ...(code === "HeightWeight" && { value: this.BmiData.value }),
        });
      }

      this.projectScoreList = list;

      // 计算总分（排除 BMI）
      const validScores = list.filter((p) => p.projectCode !== "HeightWeight");
      const total = validScores.reduce((sum, item) => sum + item.fraction, 0);
      const avg = validScores.length
        ? Math.round(total / validScores.length)
        : 0;

      let finalLevel = "不及格";
      if (avg >= 90) finalLevel = "优秀";
      else if (avg >= 80) finalLevel = "良好";
      else if (avg >= 60) finalLevel = "及格";

      this.finalScoreData = {
        finalWeightScore: avg,
        level: finalLevel,
      };
    },
    // ========== 评价建议 ==========

    analyzeStrengthsAndWeaknesses() {
      const strong = [];
      const weak = [];
      console.log(1111111111111111111111111,this.projectScoreList);
      
      this.projectScoreList.forEach((item) => {
        if (item.projectCode === "HeightWeight") return;
        if (item.level === "优秀" || item.level === "良好") {
          strong.push(item);
        } else if (item.level === "及格" || item.level === "不及格") {
          weak.push(item);
        }
      });

      // 取前1-2个强项和弱项
      this.strongItems = strong.slice(0, 2);
      this.weakItems = weak.slice(0, 2);
    },
    // 随机获取一条评语
    getRandomRemark(projectCode, level) {
      const remarks = this.projectRemarkMap[projectCode]?.[level];
      if (!remarks || remarks.length === 0) return "请继续保持锻炼！";
      return remarks[Math.floor(Math.random() * remarks.length)];
    },

    // 获取训练方法（取前2-3个）
    getTrainings(projectCode) {
      const config = this.projectConfig[projectCode];
      return config?.trainings?.slice(0, 3) || ["基础训练"];
    },
    // ========== 评价建议 ==========

    // ========== BMI 进度条 ==========
    getSegments(item) {
      return this.levels.map((label, index) => ({ label, level: label }));
    },
    getVisualRange(item) {
      const absMin = Math.min(...item.standards.map(Number));
      const absMax = Math.max(...item.standards.map(Number));
      const padding = (absMax - absMin) * 0.2;
      return { min: absMin - padding, max: absMax + padding };
    },
    segmentStyle(seg, item) {
      const colors = {
        低体重: "#0eb56c",
        正常: "#1ea5eb",
        超重: "#f3a919",
        肥胖: "#f16114",
      };
      return { "background-color": colors[seg.level] };
    },
    markerPosition(item) {
      const value = parseFloat(item.value);
      const [low, normal, high] = item.standards.map(Number);
      let pos = 0;
      if (value < low) pos = 10;
      else if (value < normal) pos = 30;
      else if (value < high) pos = 70;
      else pos = 95;
      const colors = {
        低体重: "#0eb56c",
        正常: "#1ea5eb",
        超重: "#f3a919",
        肥胖: "#f16114",
      };
      return {
        width: `${pos}%`,
        "background-color": colors[item.level],
      };
    },

    // ========== 生成长图 ==========
    async generateImage() {
      this.generating = true;
      try {
        const element = this.$refs.reportRef;
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff",
        });
        const imgData = canvas.toDataURL("image/png");

        const container = document.createElement("div");
        container.innerHTML = `
          <div style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.85); z-index: 10000; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 16px; box-sizing: border-box;">
            <button onclick="this.parentElement.parentElement.remove()" style="position: absolute; top: 20px; right: 20px; width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.3); color: white; font-size: 20px; display: flex; align-items: center; justify-content: center; cursor: pointer;">
              ×
            </button>
            <p style="margin-bottom: 20px; color: #4fc3f7; font-weight: 500; text-align: center; font-size: 16px;">长按下方图片 → 保存到相册</p>
            <div style="background: white; padding: 6px; border-radius: 12px; box-shadow: 0 8px 24px rgba(0,0,0,0.3); max-width: 100%; max-height: 80vh; display: flex; align-items: center; justify-content: center;">
              <img src="${imgData}" style="max-width: 100%; max-height: 70vh; object-fit: contain; border-radius: 8px;" />
            </div>
          </div>`;
        document.body.appendChild(container);
      } catch (error) {
        console.error("生成失败:", error);
        alert("生成失败，请重试");
      } finally {
        this.generating = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-tabs--line .van-tabs__wrap {
  border-radius: 8px;
  box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
}
@font-face {
  font-family: DINPro-Bold;
  src: url(../../../assets/font/DINPro-Bold.otf);
}
@font-face {
  font-family: douyuFont;
  src: url(../../../assets/font/douyuFont.otf);
}
.report-page {
  max-width: 800px;
  margin: 0 auto;
  background: #f9f9f9;
  padding: 0;
}
.report-container {
  background: white;
  width: 100%;
  box-sizing: border-box;
}
/* ========== 复用你原有的样式 ========== */
.page {
  background-image: url("../../../assets/parentImg/finessBg.png");
  background-size: 100% 180%;
  background-repeat: no-repeat;
  padding:clamp(12px,4vw, 22px);
  max-width: 800px;
}
.title_box {
  height: 440px;
}
.title {
  font-size: 20px;
  font-family: douyuFont;
  color: #fff;
  margin-top: 20px;
  margin-bottom: 60px;
}
.cardRoll_box {
  position: relative;
  height: 350px;
  border-radius: 15px;
  margin-top: 20px;
  box-sizing: border-box;
}
.cardRoll_badgetopbox {
  position: absolute;
  top: -40px;
  right: 4vw;
  width: 100px;
  height: 150px;
  z-index: 9999;
}
.cardRoll_topbox {
  height: 65px;
  width: calc(100% - clamp(24px,8vw, 44px));

  padding:clamp(12px,4vw, 22px);
  background-color: white;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.04);
}
.cardRoll_bottombox {
  position: relative;
  height: 250px;
  width: 100%;
  background-color: white;
  border-radius: 0 0 15px 15px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.04);
  .line {
    margin-bottom: 10px;
  }
}
.card {
  height: calc(250px - 8vw);
  width: calc(100% - 8vw);
  padding: 0 4vw;
}
.cardRoll_bottombox_top {
  display: flex;
  justify-content: space-between;
  font-family: DINPro-Bold;
  font-size: 24px;
  text-align: center;
}
.cardRoll_bottombox_topleft,
.cardRoll_bottombox_topright {
  width: 38vw;
  height: clamp(16px, 19vw, 70px);;
  line-height: clamp(16px, 19vw, 70px);;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.cardRoll_bottombox_topleft {
  background-image: url("../../../assets/parentImg/身高icon.png");
}
.cardRoll_bottombox_topright {
  background-image: url("../../../assets/parentImg/体重icon.png");
}
.cardRoll_bottombox_bottomtop {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  font-family: DINPro-Bold;
  .cardRoll_bottombox_bottomtopright {
    display: flex;
    height: 20px;
    line-height: 20px;
  }
}
.cardRoll_bottombox_bottomtopright_text {
  width: 40px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 15px;
  font-size: 12px;
  background-color: #e1eef7;
  color: #2e8bd3;
  margin-left: 8px;
}
.test-item {
  background-color: #effaff;
  margin: clamp(12px,4vw, 22px) 0;
  padding: 15px;
  border-radius: 15px;
}
.progress-container {
  height: 10px;
  background: #eee;
  border-radius: 10px;
}
.main-progress {
  height: 100%;
  border-radius: 10px;
}
.current-marker {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.reference-bar {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.segment {
  flex: 1;
  text-align: center;
  position: relative;
}
.marker {
  height: 3px;
  width: 100%;
}
.label {
  display: block;
  font-size: 12px;
  color: #89aab7;
}
.line {
  width: calc(100% - 20px);
  border-bottom: 2px dotted #dbedf7;
  margin: 0 10px;
}

/* ========== 成绩列表 ========== */
.projectBox {
  background-color: #fff;
  padding:clamp(12px,4vw, 22px);
  border-radius: 15px;
  font-size: 14px;
  margin-top: 15px;
}
.project_titleBox {
  margin-bottom: 15px;
}
.project_li {
  background-color: #fff;
  border-radius: 15px;
  margin: 15px 0;
  padding:clamp(12px,4vw, 22px);
  background-image: url("../../../assets/parentImg/project_BG.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.project_title {
  font-size: clamp(12px, 3.5vw, 18px);
  font-weight: 500;
  color: #000;
}
.project_score {
  display: flex;
  margin: 10px 0 15px 0;
}
.project_score_li {
  width: 33%;
  text-align: center;
}
.project_score_li_top {
  font-size: clamp(16px, 5.5vw, 22px);
  line-height: clamp(16px, 5.5vw, 22px);
  margin-bottom: 5px;
  color: #2e8bd3;
  font-family: DINPro-Bold;
}
.project_score_li_bottom {
  color: #2e8bd3;
  font-size: clamp(12px, 3vw, 18px);
}
.noproject_score {
  color: #2e8bd3;
  text-align: center;
  margin: 10px 0 5px 0;
}
.project_video {
  font-size: 13px;
  display: flex;
  justify-content: space-between;
}
.dfcenter {
  display: flex;
  align-items: center;
}

/* ========== 雷达图占位 ========== */
.card-eachart-placeholder {
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 16px;
}
.card-eachart-box {
  height: 300px;
  border-radius: 15px;
  background: #ffffff;
  margin: 10px 0;
  padding: 10px;
}
.card-eachart {
  height: 300px;
  width: 100%;
}
/* ========== 训练建议 ========== */
.tishengbox {
  border-radius: 15px;
  background: #ffffff;
  margin: 10px 0;
  .strongItems_title{
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      height: 60px;
      line-height: 60px;
      background-image: url("../../../assets/parentImg/tisheng_title1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
  }
  .strongItems_body{
    padding: 0 4vw 4vw 4vw;
  }
  .weakItems_title{
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      height: 60px;
      line-height: 60px;
      background-image: url("../../../assets/parentImg/tisheng_title2.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
  }
}
// .tishengbox > div:first-child {
//   font-size: 18px;
//   text-align: center;
//   margin-bottom: 10px;
// }

/* ========== 底部 ========== */
.bottom-box {
  margin: 10px 0;
  padding:clamp(12px,4vw, 22px);
  border-radius: 15px;
  background: #ffffff;
}
.qrcode-section {
  text-align: center;
  margin: 30px 0;
  padding: 20px;
}
.qrcode-section h3 {
  margin: 0 0 15px;
  color: #2c3e50;
}
.qrcode-desc {
  margin-top: 10px;
  color: #777;
  font-size: 14px;
}
.report-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
  color: #999;
  font-size: 12px;
}

/* ========== 悬浮按钮 ========== */
.fab-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
}
.fab-button {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #2ecc71;
  border: none;
  box-shadow: 0 4px 12px rgba(46, 204, 113, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.fab-button:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(46, 204, 113, 0.5);
}
@supports (bottom: env(safe-area-inset-bottom)) {
  .fab-container {
    bottom: calc(24px + env(safe-area-inset-bottom));
  }
}
</style>